<template>
  <a-article-list :articles="articles" id-field="Id">
    <template v-slot="{ article, position }">
      <a-lazy-hydrate when-visible>
        <a-news-item
          v-bind="{ [$options.consts.NEWS_ITEM_DATA_ATTRIBUTE]: true }"
          :article="article"
          :action-icons="actionIcons"
          :hide-bottom-border="checkBorder(position)"
          hide-additional-info
          :class="$options.consts.ARTICLE_SLOT_CLASS_NAME"
          v-on="$listeners"
        >
          <template v-slot:bottom>
            <a-category
              v-bind="generateCategoryProps(article)"
              class="related-article__category"
            />
          </template>
        </a-news-item>
      </a-lazy-hydrate>
      <a-banner
        v-if="isBannerPlace(position)"
        :banner-settings="getBannerSettings(position)"
        class="related-article-list-item__banner"
        use-random-banner-id
      />
    </template>
  </a-article-list>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'
import ANewsItem, { ACTION_ICON } from 'shared/ANewsItem'
import ABanner from 'shared/ABanner'
import {
  BANNER_SETTINGS,
  getInsideListBannerSettingsKey
} from 'enums/banners/banner-settings'
import { NEWS_ITEM_DATA_ATTRIBUTE } from 'enums/data-attributes'
import AArticleList from 'shared/AArticleList'
import { ARTICLE_SLOT_CLASS_NAME } from 'shared/APaginatedNewsList/enums'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'

const BANNER_POSITION = 4
const BANNERS_COUNT = 4

export const ARTICLE_ITEM_CLASS_NAME = 'related-article-list-item'

export default {
  name: 'AArticlesListWithBanners',
  components: {
    ANewsItem,
    ABanner,
    ACategory: hydrateWhenVisible(() => import('shared/ACategory'), {
      props: [
        'category-name',
        'category-slug',
        'subcategory-name',
        'subcategory-slug'
      ]
    }),
    AArticleList
  },
  props: {
    articles: propValidator([PROP_TYPES.ARRAY])
  },
  consts: { NEWS_ITEM_DATA_ATTRIBUTE, ARTICLE_SLOT_CLASS_NAME },
  data() {
    return {
      BANNER_SETTINGS,
      ARTICLE_ITEM_CLASS_NAME,
      actionIcons: [ACTION_ICON.SAVE, ACTION_ICON.SHARE]
    }
  },
  computed: {
    listLength() {
      return this.articles.length
    }
  },
  methods: {
    isBannerPlace(index) {
      return (index + 1) % BANNER_POSITION === 0
    },
    generateCategoryProps(article) {
      const {
        categoryName,
        categorySlug,
        subcategoryName,
        subcategorySlug
      } = article

      return {
        categoryName,
        categorySlug,
        subcategoryName,
        subcategorySlug
      }
    },
    getBannerSettings(index) {
      const position = index + 1

      const bannerNumber =
        (position / BANNER_POSITION) % BANNERS_COUNT || BANNERS_COUNT
      return BANNER_SETTINGS.TERM_PAGE[
        getInsideListBannerSettingsKey(bannerNumber)
      ]
    },
    checkBorder(index) {
      return this.listLength - 1 === index || this.isBannerPlace(index)
    }
  }
}
</script>

<style lang="scss" scoped>
.related-article-list-item {
  &__banner {
    margin-top: 20px;
    margin-bottom: 40px;

    @include mobile {
      margin-top: 0;
      margin-bottom: 20px;
    }
  }
}

.related-article__category {
  margin-top: 13px;
}
</style>
